export default {
  free: {
    en: 'Free',
  },
  redeemed: {
    en: 'Redeemed',
  },
  unavailable: {
    en: 'Unavailable',
  },
  buttonAreaLabel: {
    en: 'Add product to queue for {date}',
  },
}
